// 2026-08-12 — v-html 로 렌더링되는 HTML을 정제 (DOMPurify)
//
// 대부분의 v-html 대상은 서버 권한 체크(예: IsNoticeManagerOrReadOnly)로 이미
// 작성자가 제한되어 있지만, 그 계정이 피싱 등으로 뚫리면 전 직원이 보는 화면에
// 스크립트가 삽입될 수 있다. 이 유틸은 그런 경우를 막는 2차 방어선(defense-in-depth)
// 이다 — <script>, onerror= 같은 이벤트 핸들러, javascript: URL 등을 제거한다.
import DOMPurify from 'dompurify'

export function sanitizeHtml(html) {
  if (!html) return ''
  return DOMPurify.sanitize(html, {
    ADD_ATTR: ['target'], // 기존 콘텐츠의 새 창 링크(target="_blank") 유지
  })
}
